import { type SoQLType } from './';

/**
 * Options available to the query and export version 3 APIs.
 * See BaseQuery.scala Query definition for full list
 * this is not exhaustive
 */
export interface SoQLV3APIOptions {
  query?: string;
  /**
   * Whether to include synthetic columns (for example, system columns not explicitly requested)
   * @default true
   */
  includeSynthetic?: boolean;
  /**
   * Whether to include hidden columns that are viewable by the current user
   * @default true
   */
  includeAccessibleHidden?: boolean;
  page?: {
    pageSize: number;
    pageNumber: number;
  };
  /** Also known as client context variables throughout the code. */
  parameters?: {
    /** Client context variables that have been saved to the database and belong to a view. */
    qualified?: {
      /**
       * The UID of the view that the variable is created on, NOT the view you're querying. If
       * this is an inherited client context variable, use the viewId that it was inherited from.
       */
      [datasetUid: string]: V3ClientContextVariableOverrides;
    };
    /** Ad hoc client context variables */
    unqualified?: V3ClientContextVariableOverrides;
  };
  /** in seconds */
  timeout?: number;
  /**
   * How the ordering of a query's rows should be handled
   * if orderingSpecifier is not sent
   * then ordering follows only 'order by' statements and is not otherwise guaranteed
   * UNLESS the "page" option is used, then the behavior defaults to TOTAL
   */
  orderingSpecifier?: OrderingSpecifier;
  /**
   * Signifies if this query is being sent as a direct effect of ignoring data in the column's cached_contents property.
   */
  skippedCachedContents?: boolean;
}

export enum OrderingSpecifier {
  Total = 'TOTAL',
  Discard = 'DISCARD',
  NoPreserve = 'NO_PRESERVE',
}

export interface V3ClientContextVariableOverrides {
  /** The `name` field from a ClientContextVariable object */
  [clientContextVariableName: string]: {
    type: SoQLType.SoQLFloatingTimestampT | SoQLType.SoQLTextT | SoQLType.SoQLNumberT | SoQLType.SoQLBooleanT;
    value: string;
  };
}
